// Job Descriptio page
export const experienceLevelOption = [
    "Entry (0-2 years of experience)",
    "Medium (3-5 years of experience)",
    "Senior (6+ years of experience)"
];

export const interviewOptions = [
    { value: "hr-round", label: "HR Round" },
    { value: "prod-sense", label: "Product Sense" }
  ];

  export const languageOptions = [
    { value: "bg", label: "Български" },                // Bulgarian
    { value: "ca", label: "Català" },                   // Catalan
    { value: "zh", label: "中文（简体）" },                // Chinese (Mandarin, Simplified)
    { value: "zh-TW", label: "中文（繁體）" },             // Chinese (Mandarin, Traditional)
    { value: "zh-HK", label: "粵語" },                   // Chinese (Cantonese, Traditional)
    { value: "cs", label: "Čeština" },                  // Czech
    { value: "da", label: "Dansk" },                    // Danish
    { value: "nl", label: "Nederlands" },               // Dutch
    { value: "en", label: "English" },                  // English
    { value: "et", label: "Eesti" },                    // Estonian
    { value: "fi", label: "Suomi" },                    // Finnish
    { value: "nl-BE", label: "Vlaams" },                // Flemish
    { value: "fr", label: "Français" },                 // French
    { value: "fr-CA", label: "Français (Canada)" },     // French (Canada)
    { value: "de", label: "Deutsch" },                  // German
    { value: "de-CH", label: "Schweizerdeutsch" },      // German (Switzerland)
    { value: "el", label: "Ελληνικά" },                 // Greek
    { value: "hi", label: "हिन्दी" },                   // Hindi
    { value: "hu", label: "Magyar" },                   // Hungarian
    { value: "id", label: "Bahasa Indonesia" },         // Indonesian
    { value: "it", label: "Italiano" },                 // Italian
    { value: "ja", label: "日本語" },                     // Japanese
    { value: "ko", label: "한국어" },                     // Korean
    { value: "lv", label: "Latviešu" },                 // Latvian
    { value: "lt", label: "Lietuvių" },                 // Lithuanian
    { value: "ms", label: "Bahasa Melayu" },            // Malay
    { value: "multi", label: "Multilingual (Español + English)" }, // Multilingual (Spanish + English)
    { value: "no", label: "Norsk" },                    // Norwegian
    { value: "pl", label: "Polski" },                   // Polish
    { value: "pt", label: "Português" },                // Portuguese
    { value: "pt-BR", label: "Português (Brasil)" },    // Portuguese (Brazil)
    { value: "pt-PT", label: "Português (Portugal)" },  // Portuguese (Portugal)
    { value: "ro", label: "Română" },                   // Romanian
    { value: "ru", label: "Русский" },                  // Russian
    { value: "sk", label: "Slovenčina" },               // Slovak
    { value: "es", label: "Español" },                  // Spanish
    { value: "es-419", label: "Español (Latinoamérica)" }, // Spanish (Latin America)
    { value: "sv", label: "Svenska" },                  // Swedish
    { value: "sv-SE", label: "Svenska (Sverige)" },     // Swedish (Sweden)
    { value: "th", label: "ไทย" },                      // Thai
    { value: "tr", label: "Türkçe" },                   // Turkish
    { value: "uk", label: "Українська" },               // Ukrainian
    { value: "vi", label: "Tiếng Việt" }               // Vietnamese
];

// Additional Information page

export const add_info_instr = "The text entered here will help target role and skill fit."

export const add_info_instr_cont = "Most candidates ask recruiters the same questions despite having read a job description. Pre-answering these questions for the AI will significantly improve candidate quality as they move through the hiring lifecycle:"

export const add_info_common_questions = [
    "What is the product that this person will be working on?",
    "Is there a specific role already designated for the person you will hire?",
    "Is this a new or existing role?",
    "How big is the team?",
    "What is the hiring process?",
    "What are the team/organizational goals for the next 3-5 years?"
]


// AI Screening page

export const ai_scn_instr = "Please select your preferred interview questions. We will ask these on your behalf to save your time during the phone call. Our interview includes, but is not limited to, your selected questions."

export const defaultQuestions = [
    "Can you describe how your experience and skills make you a suitable candidate for this role?",
    "Can you discuss any academic accolades or projects that are particularly relevant to this role?",
    "Can you provide an example of a complex challenge you have faced in the past and how you handled it?",
    "Can you share a notable achievement in your career that you believe highlights your capability to excel in this role?",
    "How do you learn new skills?",
    "What is your biggest failure?",
    "How would you rate yourself on these three traits? And why?"
];


// Evaluation Rubrics page

export const eval_instr = "Please select the criterion for evaluating the candidate. We will rate these on a scale from 0 (does not meet qualifications) to 5 (exceeds qualifications)."

export const criteria = [
    'Culture Fit',
    'Collaboration',
    'Qualification',
    'User Empathy',
    'Analytical',
    'Relevance experience',
    'Logic Thinking',
    'Business Acumen',
    'Communication',
    'Strategy',
    'Enthusiasm',
    'Passion and creativity'
];
